// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__9YFPc","pages":"Header_pages__Zl1Rb"};